<template>
  <BaseTemplate>
    <div class="base">
      <Title :jpn="t('登録情報設定')"></Title>
      <div class="input-area">
        <SubTitle>{{ t('氏名') }}</SubTitle>
        <div class="address_area flex">
          <div class="announce-area">
            <div class="announce name">{{ lastName }}</div>
          </div>
          <div class="announce-area">
            <div class="announce name">{{ firstName }}</div>
          </div>
        </div>
        <SubTitle>{{ t('住所') }}</SubTitle>
        <div class="address_area">
          <LabelInput class="label-input" :labelText="t('郵便番号')" :annotation="t('「−」ハイフンは不要です')">
            <div class="announce-area">
              <div class="announce">{{ zipCode }}</div>
            </div>
          </LabelInput>
          <LabelInput class="label-input" labelText="都道府県" v-if="i18n_mode == 'jp'">
            <div class="announce-area">
              <div class="announce">{{ prefectureName }}</div>
            </div>
          </LabelInput>
          <LabelInput class="label-input" :labelText="t('市区町村')">
            <div class="announce-area">
              <div class="announce">{{ shiku }}</div>
            </div>
          </LabelInput>
          <LabelInput class="label-input" :labelText="t('番地')">
            <div class="announce-area">
              <div class="announce">{{ address }}</div>
            </div>
          </LabelInput>
          <LabelInput class="label-input" :labelText="t('建物名・部屋番号')" :annotation="t('配送トラブル防止のため、該当する場合は略さずに必ず記載して下さい。')">
            <div class="announce-area">
              <div>{{ building }}</div>
            </div>
          </LabelInput>
        </div>

        <SubTitle subtext="※ハイフンは不要です">{{ t('電話番号') }}</SubTitle>
        <div class="address_area">
          <TextBox class="text-box tel" inputType="text" :value="tel" :readonly="end_sms == 1" placeholder="01234567890"
            @handleTextInput="inputTel" />
          <ErrorMessage v-if="errorMessageTel" class="error-message" :message="errorMessageTel" />
          <div class="button_area">
            <BlackGradationButton class="label-input nomt sms_button" :text="t('SMS認証')" v-if="end_sms == 0"
              @handleSquareBtnClick="smsPopup" />
          </div>
        </div>

        <SubTitle subtext="※@yahooや@gmailなどを推奨します">{{ t('メールアドレス') }}</SubTitle>
        <div class="address_area">
          <LabelItem class="label-item" :text="mail" />
        </div>

        <SubTitle>{{t('紹介コード')}}</SubTitle>
        <div class="address_area">
          <div class="referralCode">{{ referral_code }}</div>
        </div>
        <div class="referral_message" v-if="referral_code != ''">SMS認証を完了され、本サイト内で1度でも決済されたことのある方のみご友人を10名様までご紹介いただけます。ご登録後ご友人がSMS認証を完了したら双方に500Pが入ります。</div>
      </div>
      <div class="button_area">
        <!-- <BlackGradationButton class="square-button" :text="t('内容を更新')" @handleSquareBtnClick="upadateUserInfo" /> -->
        <SquareButton class="label-input nomt square-button" :text="t('戻る')" @handleSquareBtnClick="goToBack" />
      </div>
    </div>
    <AlertSuccess ref="alertSuccess" :isShow="isShowAlertSuccess" :text="t('お客様情報を更新しました。')"
      v-click-outside="closeAlertSuccess" />
    <AlertSuccess ref="alertSMSSuccess" :isShow="isShowSMSAlertSuccess" :text="t('SMS認証が完了しました。')"
      v-click-outside="closeSMSAlertSuccess" />
    <SMSPopup v-if="showSMSPopup" :tel="tel" @success="smsSuccess" @closePopup="showSMSPopup = false">
    </SMSPopup>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import AlertSuccess from '@/components/atoms/AlertSuccess.vue';
import SMSPopup from '@/components/molecules/SMSPopup.vue';
import LabelItem from '@/components/molecules/LabelItem.vue';
import Title from '@/components/molecules/Title.vue';
import SubTitle from '@/components/molecules/SubTitle.vue';
import TextBox from '@/components/atoms/TextBox.vue';
import SquareButton from '@/components/atoms/SquareButton.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import LabelInput from '@/components/molecules/LabelInput.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import t from '@/plugins/i18n';

export default {
  mixins: [t],

  components: {
    BaseTemplate,
    AlertSuccess,
    LabelItem,
    TextBox,
    SMSPopup,
    ErrorMessage,
    LabelInput,
    Title,
    SubTitle,
    SquareButton,
    BlackGradationButton,
  },

  data: () => ({
    lastName: null,
    middleName: null,
    firstName: null,
    tel: null,
    mail: null,
    zipCode: null,
    prefectureId: null,
    prefectureName: '',
    country: null,
    shiku: null,
    address: null,
    building: null,
    password: null,
    point: null,
    end_sms: 0,
    referral_code: '',
    confirmPass: null,
    showSMSPopup: false,
    isShowAlertSuccess: false,
    isShowSMSAlertSuccess: false,
    errorMessageLastName: null,
    errorMessageMiddleName: null,
    errorMessageFirstName: null,
    errorMessageTel: null,
    errorMessageMail: null,
    errorMessageZipCode: null,
    errorMessagePrefectureId: null,
    errorMessageCountry: null,
    errorMessageShiku: null,
    errorMessageAddress: null,
    errorMessageBuilding: null,
  }),

  computed: {
    ...mapGetters({
      prefectureList: 'prefecture/prefectureList',
      currentUser: 'user/currentUser',
      currentUserDetail: 'user/currentUserDetail',
      currentAddress: 'zipCode/currentAddress',
      changeUserInformationResult: 'user/changeUserInformationResult',
      logOutUserResult: 'user/logOutUserResult',
    }),
  },

  watch: {
    currentAddress(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          const { result } = newVal;
          this.selectPrefectureId(result[0].prefcode);
          this.inputShiku(`${result[0].address2}${result[0].address3}`);
        }
      }
    },
    currentUserDetail(newResult) {
      // this.$nextTick(() => {
      this.lastName = newResult.lastName;
      this.middleName = newResult.middleName;
      this.firstName = newResult.firstName;
      this.tel = newResult.tel;
      this.mail = newResult.mail;
      this.zipCode = newResult.zipcode;
      this.prefectureId = newResult.pref_id;
      this.prefectureName = newResult.pref_name;
      this.country = newResult.country;
      this.shiku = newResult.shiku;
      this.address = newResult.address;
      this.building = newResult.building;
      this.point = newResult.availablePoint;
      this.end_sms = newResult.end_sms;
      this.referral_code = newResult.referral_code;
      // MEMO: 都道府県リストが更新されないため、レンダリング完了を待ち、さらに少し時間差をつける。（100に根拠はないが、リロードして動作を確認）
      //   setTimeout(() => {
      //     this.prefectureId = newResult.pref_id;
      //   }, 100);
      // });
    },
    changeUserInformationResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.$store.dispatch('user/clearChangeUserInformationResult');
          this.isShowAlertSuccess = true;
        } else {
          const {
            lastName, firstName, middleName, tel, mail, zipcode,
            pref_id: prefId, shiku, address, building,
          } = newVal.errors;
          this.errorMessageLastName = lastName ? lastName[0] : null;
          this.errorMessageMiddleName = middleName ? middleName[0] : null;
          this.errorMessageFirstName = firstName ? firstName[0] : null;
          this.errorMessageTel = tel ? tel[0] : null;
          this.errorMessageMail = mail ? mail[0] : null;
          this.errorMessageZipCode = zipcode ? zipcode[0] : null;
          this.errorMessagePrefectureId = prefId ? prefId[0] : null;
          this.errorMessageShiku = shiku ? shiku[0] : null;
          this.errorMessageAddress = address ? address[0] : null;
          this.errorMessageBuilding = building ? building[0] : null;
        }
      }
    },
  },

  created() {
    this.$store.dispatch('prefecture/setPrefectureList');
    this.$store.dispatch('user/setCurrentUserDetail');
  },

  methods: {
    inputLastName(lastName) {
      this.lastName = lastName;
    },
    inputFirstName(firstName) {
      this.firstName = firstName;
    },
    inputMiddleName(name) {
      this.middleName = name;
    },
    inputTel(tel) {
      this.tel = tel;
    },
    inputMail(mail) {
      this.mail = mail;
    },
    inputZipCode(zipCode) {
      this.zipCode = zipCode;
    },
    inputCountry(country) {
      this.country = country;
    },
    selectPrefectureId(prefectureId) {
      this.prefectureId = prefectureId;
    },
    inputShiku(shiku) {
      this.shiku = shiku;
    },
    inputAddress(address) {
      this.address = address;
    },
    inputBuilding(building) {
      this.building = building;
    },
    changeZipCode() {
      if (this.i18n_mode === 'jp') {
        const zipCodeLength = 7;
        if (String(this.zipCode).length === zipCodeLength) {
          const postParams = {
            zipcode: this.zipCode,
          };
          this.$store.dispatch('zipCode/setCurrentAddress', { postParams });
        }
      }
    },
    smsPopup() {
      if (window.confirm(this.t('SMSコードを送信しますか？'))) {
        this.showSMSPopup = true;
      }
    },
    goToBack() {
      this.$router.push('/my-page');
    },
    goToChangePassword() {
      this.$router.push('/change-password');
    },
    upadateUserInfo() {
      if (this.i18n_mode !== 'jp') {
        this.prefectureId = 99;
      }
      const postParams = {
        lastName: this.lastName,
        middleName: this.middleName,
        firstName: this.firstName,
        tel: this.tel,
        mail: this.mail,
        zipcode: this.zipCode,
        pref_id: this.prefectureId,
        country: this.country,
        shiku: this.shiku,
        address: this.address,
        building: this.building,
      };
      this.$store.dispatch('user/changeUserInformation', { postParams });
    },
    closeAlertSuccess() {
      this.isShowAlertSuccess = false;
    },
    closeSMSAlertSuccess() {
      this.isShowSMSAlertSuccess = false;
    },
    smsSuccess() {
      this.showSMSPopup = false;
      this.$store.dispatch('user/setCurrentUserDetail');
      this.isShowSMSAlertSuccess = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.base {
  padding-top: 30px;
  padding-bottom: 50px;
  max-width: 600px;
  margin: auto;

  .input-area {
    margin: 40px 0;

    .address_area {
      padding: 0 30px;
      margin: 10px 0;

      .row {
        margin: 5px 0;
      }

      .label-input {
        margin-top: 10px;
      }
    }

    .flex {
      display: flex;
      width: 100%;

      .last-name-container {
        flex: 1 1 150px;
        min-width: 0;
      }

      .first-name-container {
        flex: 1 1 150px;
        min-width: 0;
        margin-left: 15px;
      }
    }

    .announce-area {
      display: flex;
      align-items: center;

      .announce {
        color: $black;
        margin-left: 10px;
        font-size: 14px;
        width: 300px;
      }
      .name {
        width: auto;
      }
    }
  }

  .button_area {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .square-button {
      max-width: 200px;
      width: 100%;

      &:nth-child(2) {
        margin-top: 10px;
      }
    }
  }

  .referralCode {
    margin-left: 10px;
    font-size: 24px;
  }
}

@media screen and (max-width: $tabletWidth) {
  .base {
    .input-area {
      margin: 10px 0;
    }
  }

  .referralCode {
    text-align: center;
    margin-left: 0;
  }
}
</style>
